import { render, staticRenderFns } from "./ChuongTrinhList.vue?vue&type=template&id=dc128f88&"
import script from "./ChuongTrinhList.vue?vue&type=script&lang=js&"
export * from "./ChuongTrinhList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports